class Popupredirection {
    static init() {

        if (document.querySelector('.js-open-popup') && document.querySelector('.popup-redirection__wrapper')) {
            // Get link
            var link = document.querySelector('.js-open-popup');
            link = link.href;

            const closePopup = document.querySelectorAll('.js-close-popup');
            const openPopup = document.querySelectorAll('.js-open-popup');
            const openLinkBtn = document.querySelector('.js-open-link');
            const popup = document.querySelector('.popup-redirection__wrapper');

            openLinkBtn.href = link;

            closePopup.forEach(btn => {
                btn.addEventListener('click', () => {
                    if (popup.classList.contains('open')) {
                        popup.classList.remove('open')
                    }
                })
            })
            openPopup.forEach(btn => {
                btn.addEventListener('click', (e) => {
                		e.preventDefault();
                    if (!popup.classList.contains('open')) {
                        popup.classList.add('open')
                    }
                })
            })
        }
    }
}

export default Popupredirection;


// WEBPACK FOOTER //
// ./src/scripts/components/popupredirection.js